import { FC, MouseEvent } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Header from './Header'
import Messages from './Messages'
import Sender from './Sender'
import './Chat.css'

interface ChatProps {
  sendMessage: (message: Message) => void;
  onStopSimulation: (event: MouseEvent) => void;
};

const Chat: FC<ChatProps> = ({ sendMessage, onStopSimulation }: ChatProps) => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <Header onStopSimulation={onStopSimulation}/>
        <Messages />
        <Sender sendMessage={sendMessage}/>
      </div>
    );
};

Chat.defaultProps = { };

export default Chat;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
    width: "358px",
    position: "absolute",
    right: "0%",
    top: "0%",
    backgroundColor: "#e5ddd6",
    zIndex: 100,
  },
  panelContent: {
    height: "79.5%",
    overflow: "auto",
    overscrollBehaviorY: "contain",
  },
}));
